import React, { Component } from 'react'
import { Container } from '@sencha/ext-modern'
import Message from '../../components/Message'
import SearchBar from './SearchBar'
import ListItem from './ListItem'
import ExpenseTypeSelect from './ExpenseTypeSelect'

Ext.require([
    'Ext.dataview.listswiper.ListSwiper',
    'Ext.MessageBox'
])
const style = {
    outer: {
        backgroundColor: "#f5f5f5",
        paddingTop: "10px",
        paddingBottom: "10px"
    }
}
class AdministrativeApproval extends Component {
    state = {
        query: '',
        loading: false,
        errorMessage: null,
        selectedStatus: 0,
        ExpenseList: null,
        pageCount: 10,
        page: 1,
        totalCount: 0
    }

    componentDidMount() {
        const { pageCount } = this.state
        this.GetAdministrativeApprovalList(pageCount)
    }

    GetAdministrativeApprovalList = (row) => {
        const { query, selectedStatus } = this.state
        const { match: { params: { type } } } = this.props
        Tyan.doPostEvent('GetAdministrativeApprovalList', {
            data: { type, status: selectedStatus, row, query, },
            onRequest: () => {
                this.setState({ loading: true })
            },
            onEnd: ({ errorMessage, expenseList, totalCount, statusList }) => {
                if (errorMessage) {
                    this.setState({ errorMessage })
                    return
                }
                this.setState({ loading: false, expenseList, totalCount, statusList })
            }
        })
    }

    handleLoadMore = () => {
        let { page, pageCount } = this.state
        page += 1
        this.GetAdministrativeApprovalList(pageCount * page)
        this.setState({ page })
    }

    handleChange = (field, value) => {
        this.setState({ query: value })
    }

    handleSearch = () => {
        const { pageCount } = this.state
        this.GetAdministrativeApprovalList(pageCount)
    }

    handleSelectStatus = (e) => {
        this.setState({ selectedStatus: e.value })
        const { pageCount } = this.state
        this.GetAdministrativeApprovalList(pageCount)
    }

    handleChildTap = ({ objectID, type, fields: { 名称 } }) => {
        console.log('名称',名称)
        switch (type) {
            case "预支签核":
                location.hash = `/QYWX/AdvanceApply/${objectID}`
                break
            case "报支签核":
                location.hash = `/QYWX/ExpenseApply/${objectID}/${名称 == "出差/外训报支单" ? "出差外训报支单" : 名称}`
                break
            case "请购签核":
                location.hash = `QYWX/RequisitionApply/${objectID}`
                break
            case "采购签核":
                location.hash = `QYWX/PurchaseApply/${objectID}`
                break
            case "OA签核":
                location.hash = `/QYWX/FlowRecordDetail/${objectID}/0/1`
                break
            case "人事签核":
                switch (名称) {
                    case '忘刷卡申请':
                        location.hash = `QYWX/ForgetSwipeCardApply/${objectID}`
                        break
                    case '加班申请':
                        location.hash = `QYWX/OverTimeApply/${objectID}`
                        break
                    case '请假申请':
                        location.hash = `QYWX/OutApply/${objectID}`
                        break
                }
                break
        }
        return
    }

    render() {
        const { expenseList, errorMessage, query, selectedStatus, totalCount, statusList } = this.state
        if (errorMessage) {
            return <Message text="数据加载失败" subText={errorMessage} />
        } else if (!expenseList) {
            return <Message text="数据加载中..." />
        }

        return (
            <Container layout={{ type: "vbox" }} style={style.outer} scrollable >
                <SearchBar selectedStatus={selectedStatus} statusList={statusList.map(o => [o, o])} handleChange={this.handleChange} handleSearch={this.handleSearch} query={query} handleSelectStatus={this.handleSelectStatus} />
                <ListItem listData={expenseList} totalCount={totalCount} handleLoadMore={this.handleLoadMore} handleChildTap={this.handleChildTap} />
            </Container>
        )
    }
}
export default AdministrativeApproval